import { FC } from 'react';
import { PublicForm as PublicFormFillingExperience } from '../../actual';
import { FillingExperienceProps } from '../../filling-experience.type';

export const PublicForm: FC<FillingExperienceProps> = (props) => {
  return <PublicFormFillingExperience {...props} isPreviewMode={true} />;
};
